import numeral from 'numeral';
import {useCallback} from 'react';
import useSearchParams from './useSearchParams.js';
import {DEFAULT_ZOOM} from '@app/constants';

function formatCoordinate(coord) {
  return numeral(coord).format('0.[00000]');
}
export default function () {
  const {searchParams, setSearchParams} = useSearchParams();

  const locParam = searchParams.get('loc');

  const [latString, lonString, zoomString] = locParam
    ? locParam.split(',')
    : [];

  const center =
    latString && lonString ? [Number(lonString), Number(latString)] : [0, 0];

  const zoom = zoomString ? Number(zoomString.replace('z', '')) : DEFAULT_ZOOM;

  const setLocation = useCallback(
    (center, zoom) => {
      const loc = `${formatCoordinate(center[1])},${formatCoordinate(center[0])},${zoom.toFixed(2)}z`;
      searchParams.set('loc', loc);

      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  const resetLocation = useCallback(() => {
    const center = [0, 0];
    setLocation(center, DEFAULT_ZOOM);
  }, [setLocation]);

  return {center, zoom, setLocation, resetLocation};
}
